export default "__VITE_ASSET__DSECrK2y__"